export const SUBCLASS_FEATURES = {
    // Barbarian (Starts Lv 3)
    'Path of the Berserker': [
        { level: 3, name: 'Frenzy', type: 'Passive', desc: 'Rage bonus damage (d6) on first hit each turn. No exhaustion.' }, // 2024 Update: No exhaustion, dmg dice
        { level: 6, name: 'Mindless Rage', type: 'Passive', desc: 'Immune to charm/frighten while raging.' },
        { level: 10, name: 'Retaliation', type: 'Reaction', desc: 'Attack when damaged by adjacent creature.' }, // Moved from 14
        { level: 14, name: 'Intimidating Presence', type: 'Bonus Action', desc: 'Frighten enemies in 30ft.' } // Swapped/Modified
    ],
    'Path of the Wild Heart': [
        { level: 3, name: 'Animal Speaker', type: 'Passive', desc: 'Cast Beast Sense & Speak with Animals.' },
        { level: 3, name: 'Rage of the Wilds', type: 'Passive', desc: 'Choose Bear (Resist), Eagle (Disengage), Wolf (Adv Allies).' },
        { level: 6, name: 'Aspect of the Beast', type: 'Passive', desc: 'Choose a magical aspect (Elephant, Owl, Spider, etc).' },
        { level: 10, name: 'Nature\'s Speaker', type: 'Action', desc: 'Cast Commune with Nature.' },
        { level: 14, name: 'Power of the Wilds', type: 'Passive', desc: 'Greater totem power (Ram, Lion, Falcon).' }
    ],
    'Path of the World Tree': [
        { level: 3, name: 'Vitality of the Tree', type: 'Passive', desc: 'Gain THP when raging. Grant THP to ally.' },
        { level: 6, name: 'Branches of the Tree', type: 'Reaction', desc: 'Teleport ally or reduce speed of enemy.' },
        { level: 10, name: 'Battering Roots', type: 'Passive', desc: 'Reach +10ft, Push/Topple on hit.' },
        { level: 14, name: 'Travel along the Tree', type: 'Action', desc: 'Teleport group via trees.' }
    ],
    'Path of the Zealot': [
        { level: 3, name: 'Divine Fury', type: 'Free', desc: 'Extra necrotic/radiant damage while raging.' },
        { level: 3, name: 'Warrior of the Gods', type: 'Passive', desc: 'Revivify is free on you. Pool of healing dice.' }, // 2024 adds healing pool?
        { level: 6, name: 'Fanatical Focus', type: 'Free', desc: 'Reroll failed save or damage die.' },
        { level: 10, name: 'Zealous Presence', type: 'Bonus Action', desc: 'Grant advantage to allies.' },
        { level: 14, name: 'Rage beyond Death', type: 'Passive', desc: 'Become a ghost-like warrior on death resist.' } // 2024 Changed significantly, prevents death
    ],

    // Bard (Starts Lv 3)
    'College of Lore': [
        { level: 3, name: 'Cutting Words', type: 'Reaction', cost: 'Die', desc: 'Subtract Inspiration die from roll (Check/Attack/Dmg).' },
        { level: 3, name: 'Bonus Proficiencies', type: 'Passive', desc: '3 Extra Skills.' },
        { level: 6, name: 'Additional Magical Secrets', type: 'Passive', desc: 'Learn 2 spells from any class.' },
        { level: 14, name: 'Peerless Skill', type: 'Free', cost: 'Die', desc: 'Add die to ability check.' }
    ],
    'College of Dance': [
        { level: 3, name: 'Dazzling Footwork', type: 'Passive', desc: 'Unarmed Strike uses Bard die. No Armor AC.' },
        { level: 6, name: 'Inspiring Movement', type: 'Reaction', desc: 'Move ally out of harm when enemy ends turn.' },
        { level: 14, name: 'Leading Evasion', type: 'Passive', desc: 'Grant Evasion to allies within 5ft.' }
    ],
    'College of Glamour': [
        { level: 3, name: 'Mantle of Inspiration', type: 'Bonus Action', desc: 'Grant THP and movement to allies.' },
        { level: 6, name: 'Mantle of Majesty', type: 'Bonus Action', desc: 'Cast Command as BA freely for 1 min.' },
        { level: 14, name: 'Unbreakable Majesty', type: 'Bonus Action', desc: 'Sanctuary-like effect + Command on hit.' }
    ],
    'College of Valor': [
        { level: 3, name: 'Combat Inspiration', type: 'Passive', desc: 'Add die to damage or AC.' },
        { level: 6, name: 'Extra Attack', type: 'Passive', desc: 'Attack twice. Replace one with Cantrip.' },
        { level: 14, name: 'Battle Magic', type: 'Bonus Action', desc: 'Attack as BA after casting spell.' }
    ],

    // Cleric (Starts Lv 3)
    'Life Domain': [
        { level: 3, name: 'Disciple of Life', type: 'Passive', desc: 'Extra healing (2+Level) on spells.' },
        { level: 3, name: 'Preserve Life', type: 'Action', cost: 'Channel Divinity', desc: 'Heal injured creatures up to half HP.' },
        { level: 6, name: 'Blessed Healer', type: 'Passive', desc: 'Healing others heals you.' },
        { level: 17, name: 'Supreme Healing', type: 'Passive', desc: 'Maximize healing dice.' }
    ],
    'Light Domain': [
        { level: 3, name: 'Warding Flare', type: 'Reaction', desc: 'Disadvantage on attacker.' },
        { level: 3, name: 'Radiance of the Dawn', type: 'Action', cost: 'Channel Divinity', desc: 'AOE Radiant damage.' },
        { level: 6, name: 'Improved Flare', type: 'Passive', desc: 'Use Warding Flare on allies.' },
        { level: 17, name: 'Corona of Light', type: 'Action', desc: 'Disadvantage on saves vs your fire/radiant spells.' }
    ],
    'Trickery Domain': [
        { level: 3, name: 'Blessing of the Trickster', type: 'Action', desc: 'Advantage on Stealth for ally.' },
        { level: 3, name: 'Invoke Duplicity', type: 'Bonus Action', cost: 'Channel Divinity', desc: 'Create illusionary double. Cast from it.' },
        { level: 6, name: 'Trickster\'s Magic', type: 'Bonus Action', desc: 'Teleport or Invisible.' }, // Replaced Cloak of Shadows?
        { level: 17, name: 'Improved Duplicity', type: 'Passive', desc: 'Create 4 duplicates. Move them together.' }
    ],
    'War Domain': [
        { level: 3, name: 'War Priest', type: 'Bonus Action', desc: 'Attack as BA if you take Attack action.' }, // 2024: Unlimited? No, usage based?
        { level: 3, name: 'Guided Strike', type: 'Reaction', cost: 'Channel Divinity', desc: '+10 to hit.' },
        { level: 6, name: 'War God\'s Blessing', type: 'Reaction', cost: 'Channel Divinity', desc: 'Cast Shield of Faith or Spiritual Weapon free?' }, // 2024 might differ
        { level: 17, name: 'Avatar of Battle', type: 'Passive', desc: 'Resistance to non-magical weapon damage.' }
    ],

    // Druid (Starts Lv 3)
    'Circle of the Land': [
        { level: 3, name: 'Land\'s Aid', type: 'Action', cost: 'Wild Shape', desc: 'AOE Heal/Harm.' },
        { level: 6, name: 'Natural Recovery', type: 'Free', desc: 'Regain spell slots on Short Rest.' },
        { level: 10, name: 'Nature\'s Ward', type: 'Passive', desc: 'Immune to poison/disease, charm/frighten by elementals/fey.' },
        { level: 14, name: 'Nature\'s Sanctuary', type: 'Passive', desc: 'Beasts/Plants hesitant, Resistance.' }
    ],
    'Circle of the Moon': [
        { level: 3, name: 'Combat Wild Shape', type: 'Bonus Action', desc: 'Wild Shape as BA. AC=13+Wis. THP = 3*Level.' },
        { level: 3, name: 'Moon Fire', type: 'Action', desc: 'Radiant attack in Wild Shape.' },
        { level: 6, name: 'Improved Circle Forms', type: 'Passive', desc: 'AC increases.' },
        { level: 10, name: 'Moonlight Step', type: 'Bonus Action', desc: 'Teleport 30ft, Adv on next attack.' },
        { level: 14, name: 'Lunar Form', type: 'Passive', desc: 'Add 1d10 Radiant to attacks.' }
    ],
    'Circle of the Sea': [
        { level: 3, name: 'Wrath of the Sea', type: 'Bonus Action', cost: 'Wild Shape', desc: 'Emanate stormy aura (Thunder/Cold dmg).' },
        { level: 6, name: 'Aquatic Affinity', type: 'Passive', desc: 'Swim speed and water breathing.' },
        { level: 10, name: 'Stormborn', type: 'Passive', desc: 'Fly speed and resistance.' },
        { level: 14, name: 'Oceanic Gift', type: 'Passive', desc: 'Share benefits with allies.' }
    ],
    'Circle of the Stars': [
        { level: 3, name: 'Starry Form', type: 'Bonus Action', cost: 'Wild Shape', desc: 'Assume starry form (Archer/Chalice/Dragon).' },
        { level: 3, name: 'Star Map', type: 'Passive', desc: 'Guidance/Guiding Bolt prepared.' },
        { level: 6, name: 'Cosmic Omen', type: 'Reaction', desc: 'Add/Subtract d6 to roll.' },
        { level: 10, name: 'Twinkling Constellations', type: 'Passive', desc: 'Change form each turn. d6 becomes d8.' },
        { level: 14, name: 'Full of Stars', type: 'Passive', desc: 'Resistance to B/P/S while in form.' }
    ],

    // Fighter (Starts Lv 3)
    'Champion': [
        { level: 3, name: 'Improved Critical', type: 'Passive', desc: 'Crit on 19-20. Adv on Initiative/Athletics?' }, // 2024 buffed Remarkable
        { level: 7, name: 'Remarkable Athlete', type: 'Passive', desc: 'Add half prof to Str/Dex/Con checks. Jump distance.' },
        { level: 10, name: 'Heroic Warrior', type: 'Passive', desc: 'Heroic Inspiration on crit.' }, // New 2024
        { level: 15, name: 'Superior Critical', type: 'Passive', desc: 'Crit on 18-20.' },
        { level: 18, name: 'Survivor', type: 'Passive', desc: 'Regain HP (5+Con) each turn if <50%. Advantage on Death saves.' }
    ],
    'Battle Master': [
        { level: 3, name: 'Combat Superiority', type: 'Passive', desc: '4 Dice (d8). 3 Maneuvers. Student of War.' },
        { level: 7, name: 'Know Your Enemy', type: 'Bonus Action', desc: 'Learn stats of observed enemy (Resistances/Immunities).' },
        { level: 10, name: 'Improved Combat Superiority', type: 'Passive', desc: 'Dice become d10.' },
        { level: 15, name: 'Relentless', type: 'Passive', desc: 'Regain one (free) die if you start turn with none.' }, // Buffed
        { level: 18, name: 'Improved Combat Superiority (2)', type: 'Passive', desc: 'Dice become d12.' }
    ],
    'Eldritch Knight': [
        { level: 3, name: 'Spellcasting', type: 'Passive', desc: 'Wizard spells (Divination/Abjuration removed restriction).' },
        { level: 3, name: 'Weapon Bond', type: 'Bonus Action', desc: 'Bond with weapon, summon it.' },
        { level: 7, name: 'War Magic', type: 'Action', desc: 'Replace one attack with Cantrip.' }, // Changed to "War Magic" inside Attack action
        { level: 10, name: 'Eldritch Strike', type: 'Passive', desc: 'Hit imposes disadvantage on next save.' },
        { level: 15, name: 'Arcane Charge', type: 'Free', desc: 'Teleport 30ft when Action Surging.' },
        { level: 18, name: 'Improved War Magic', type: 'Action', desc: 'Replace two attacks with Level 1/2 Spell.' }
    ],
    'Psi Warrior': [
        { level: 3, name: 'Psionic Power', type: 'Passive', desc: 'Psionic Energy dice to fuel powers.' },
        { level: 7, name: 'Telekinetic Adept', type: 'Passive', desc: 'Move objects/creatures. Fly.' },
        { level: 10, name: 'Guarded Mind', type: 'Passive', desc: 'Resistance to psychic, end charm/frighten.' },
        { level: 15, name: 'Bulwark of Force', type: 'Bonus Action', desc: 'Grant cover to allies.' },
        { level: 18, name: 'Telekinetic Master', type: 'Action', desc: 'Cast Telekinesis.' }
    ],

    // Monk (Starts Lv 3) - Features mostly OK, levels correct
    'Warrior of Mercy': [
        { level: 3, name: 'Hand of Harm/Healing', type: ['Action', 'Free'], desc: 'Spend Focus to heal or deal necrotic damage.' },
        { level: 6, name: 'Physician\'s Touch', type: 'Passive', desc: 'Remove condition / Poison.' },
        { level: 11, name: 'Flurry of Healing and Harm', type: 'Passive', desc: 'Use Hand of H/H with Flurry.' },
        { level: 17, name: 'Hand of Ultimate Mercy', type: 'Action', desc: 'Resurrect creature.' }
    ],
    'Warrior of Shadow': [
        { level: 3, name: 'Shadow Arts', type: 'Bonus Action', desc: 'Darkness (moveable). Darkvision.' },
        { level: 6, name: 'Shadow Step', type: 'Bonus Action', desc: 'Teleport 60ft in dim light. Adv on attack.' },
        { level: 11, name: 'Cloak of Shadows', type: 'Bonus Action', desc: 'Become invisible in dim light (Spend Focus to ignore light req).' },
        { level: 17, name: 'Opportunist', type: 'Reaction', desc: 'Attack enemy hit by ally.' }
    ],
    'Warrior of the Elements': [
        { level: 3, name: 'Elemental Attunement', type: 'Bonus Action', desc: 'Reach +10ft. Push/Pull 10ft. Elemental Dmg.' },
        { level: 6, name: 'Elemental Burst', type: 'Action', cost: '2 Focus', desc: 'AOE Damage (Fireball-like).' },
        { level: 11, name: 'Elemental Stride', type: 'Passive', desc: 'Fly/Swim speed equal to walk.' },
        { level: 17, name: 'Elemental Epitome', type: 'Passive', desc: 'Resistance, Damage aura, Destructive stride.' }
    ],
    'Warrior of the Open Hand': [
        { level: 3, name: 'Open Hand Technique', type: ['Bonus Action', 'Free'], desc: 'Add effects to Flurry of Blows (Topple/Push/NoReaction).' },
        { level: 6, name: 'Wholeness of Body', type: 'Bonus Action', desc: 'Heal and regain Focus.' },
        { level: 11, name: 'Fleet Step', type: 'Passive', desc: 'Step of the Wind helps allies?' }, // 2024 Mechanics slightly distinct
        { level: 17, name: 'Quivering Palm', type: 'Action', cost: '3 Focus', desc: 'Lethal vibrations (10d10).' }
    ],

    // Paladin (Starts Lv 3)
    'Oath of Devotion': [
        { level: 3, name: 'Sacred Weapon', type: 'Bonus Action', cost: 'Channel Divinity', desc: 'Add Cha to hit, radiant weapon.' },
        { level: 7, name: 'Aura of Devotion', type: 'Passive', desc: 'Immunity to charm aura.' },
        { level: 15, name: 'Smite of Protection', type: 'Passive', desc: 'Grant Half Cover when smiting.' },
        { level: 20, name: 'Holy Nimbus', type: 'Bonus Action', desc: 'Radiant damage/protection aura.' }
    ],
    'Oath of Glory': [
        { level: 3, name: 'Peerless Athlete', type: 'Bonus Action', cost: 'Channel Divinity', desc: 'Advantage on athletics/acrobats.' },
        { level: 3, name: 'Inspiring Smite', type: 'Free', desc: 'Distribute THP after Smite.' },
        { level: 7, name: 'Aura of Alacrity', type: 'Passive', desc: 'Increase speed aura.' },
        { level: 15, name: 'Glorious Defense', type: 'Reaction', desc: 'AC bonus against attack.' },
        { level: 20, name: 'Living Legend', type: 'Bonus Action', desc: 'Reroll saves, advantage on Cha checks.' }
    ],
    'Oath of the Ancients': [
        { level: 3, name: 'Nature\'s Wrath', type: 'Bonus Action', cost: 'Channel Divinity', desc: 'Restrain enemy.' },
        { level: 7, name: 'Aura of Warding', type: 'Passive', desc: 'Resistance to Necrotic/Psychic/Radiant damage.' }, // 2024 Changed from Spell Dmg
        { level: 15, name: 'Undying Sentinel', type: 'Passive', desc: 'Drop to 1 HP instead of 0.' },
        { level: 20, name: 'Elder Champion', type: 'Bonus Action', desc: 'Regen HP, cast spell as BA.' }
    ],
    'Oath of Vengeance': [
        { level: 3, name: 'Vow of Enmity', type: 'Bonus Action', cost: 'Channel Divinity', desc: 'Advantage on attacks vs target (Transfers on kill).' },
        { level: 7, name: 'Relentless Avenger', type: 'Reaction', desc: 'Move after opportunity attack (Speed reduced for target).' },
        { level: 15, name: 'Soul of Vengeance', type: 'Reaction', desc: 'Attack target when it attacks.' },
        { level: 20, name: 'Avenging Angel', type: 'Bonus Action', desc: 'Wings and fear aura.' }
    ],

    // Ranger (Starts Lv 3)
    'Hunter': [
        { level: 3, name: 'Hunter\'s Prey', type: 'Passive', desc: 'Colossus Slayer (d8 dmg) OR Horde Breaker (Extra attack).' },
        { level: 3, name: 'Hunter\'s Lore', type: 'Passive', desc: 'Know Immunities/Resistances of marked target.' },
        { level: 7, name: 'Defensive Tactics', type: 'Passive', desc: 'Escape the Horde (Dodge BA? No) / Multiattack Defense / Steel Will.' },
        { level: 11, name: 'Superior Hunter\'s Prey', type: 'Passive', desc: 'Deal damage to another creature.' },
        { level: 15, name: 'Superior Hunter\'s Defense', type: 'Passive', desc: 'Evasion or Uncanny Dodge.' }
    ],
    'Beast Master': [
        { level: 3, name: 'Primal Companion', type: 'Action', desc: 'Summon Beast of the Land/Air/Sea.' },
        { level: 7, name: 'Exceptional Training', type: 'Bonus Action', desc: 'Beast acts magically (Dash/Disengage/Help as BA).' },
        { level: 11, name: 'Bestial Fury', type: 'Passive', desc: 'Beast attacks twice. Beast uses Hunt\'s Mark.' },
        { level: 15, name: 'Share Spells', type: 'Passive', desc: 'Spells affect beast too.' }
    ],
    'Fey Wanderer': [
        { level: 3, name: 'Dreadful Strikes', type: 'Passive', desc: 'Extra psychic damage.' },
        { level: 3, name: 'Otherworldly Glamour', type: 'Passive', desc: 'Add Wis to Cha checks.' },
        { level: 7, name: 'Beguiling Twist', type: 'Reaction', desc: 'Charm/Frighten immune success -> Charm/Frighten other.' },
        { level: 11, name: 'Fey Reinforcements', type: 'Action', desc: 'Summon Fey (Summon Fey spell).' },
        { level: 15, name: 'Misty Wanderer', type: 'Action', desc: 'Misty Step + Ally. Invisible.' }
    ],
    'Gloom Stalker': [
        { level: 3, name: 'Dread Ambusher', type: 'Passive', desc: 'Bonus Init (+Wis). First turn: Speed +10, Extra Attack (+d8).' },
        { level: 3, name: 'Umbral Sight', type: 'Passive', desc: 'Darkvision 60ft. Invisible to Darkvision.' },
        { level: 7, name: 'Iron Mind', type: 'Passive', desc: 'Proficiency in Wis saves.' },
        { level: 11, name: 'Stalker\'s Flurry', type: 'Passive', desc: 'Miss? Make another attack. OR Hit -> Damage.' },
        { level: 15, name: 'Shadowy Dodge', type: 'Reaction', desc: 'Impose disadvantage. Teleport?' }
    ],

    // Rogue (Starts Lv 3)
    'Thief': [
        { level: 3, name: 'Fast Hands', type: 'Bonus Action', desc: 'Use Object, Sleight of Hand, or Thieves\' Tools. Magic Item Use?' },
        { level: 3, name: 'Second-Story Work', type: 'Passive', desc: 'Climbing speed is walking speed.' },
        { level: 9, name: 'Supreme Sneak', type: 'Passive', desc: 'Advantage on Stealth. Cunning Strike: Stealth Attack.' },
        { level: 13, name: 'Use Magic Device', type: 'Passive', desc: 'Attune 4 items. Use Scrolls.' },
        { level: 17, name: 'Thief\'s Reflexes', type: 'Passive', desc: 'Two turns in first round.' }
    ],
    'Arcane Trickster': [
        { level: 3, name: 'Spellcasting', type: 'Passive', desc: 'Wizard spells.' },
        { level: 3, name: 'Mage Hand Legerdemain', type: 'Passive', desc: 'Invisible Mage Hand, finer control.' },
        { level: 9, name: 'Magical Ambush', type: 'Passive', desc: 'Disadvantage on saves if hidden.' },
        { level: 13, name: 'Versatile Trickster', type: 'Bonus Action', desc: 'Mage Hand grants advantage. Trip.' },
        { level: 17, name: 'Spell Thief', type: 'Reaction', desc: 'Steal spell cast at you.' }
    ],
    'Assassin': [
        { level: 3, name: 'Assassinate', type: 'Passive', desc: 'Advantage vs not acted. High damage if surprised.' },
        { level: 9, name: 'Infiltration Expertise', type: 'Passive', desc: 'Copy writing/speech. Create identities.' },
        { level: 13, name: 'Envenom Weapons', type: 'Passive', desc: 'Poison damage ignores resistance (2d6).' },
        { level: 17, name: 'Death Strike', type: 'Passive', desc: 'Double damage on assassinate (Con save).' }
    ],
    'Soulknife': [
        { level: 3, name: 'Psychic Blades', type: ['Action', 'Bonus Action'], desc: 'Manifest psychic blades (Finesse/Thrown). Option for BA attack.' },
        { level: 9, name: 'Soul Blades', type: 'Passive', desc: 'Homing strikes (Add die to hit) / Teleport.' },
        { level: 13, name: 'Psychic Veil', type: 'Action', desc: 'Invisibility for 1 hour.' },
        { level: 17, name: 'Rend Mind', type: 'Action', desc: 'Stun target on Sneak Attack.' }
    ],

    // Sorcerer (Starts Lv 3)
    'Draconic Sorcery': [
        { level: 3, name: 'Draconic Resilience', type: 'Passive', desc: 'AC 13+Dex. +1 HP/Level.' },
        { level: 6, name: 'Elemental Affinity', type: 'Passive', desc: 'Add Cha to damage of element. Resistance.' },
        { level: 14, name: 'Dragon Wings', type: 'Bonus Action', desc: 'Fly speed same as walk. Hover.' },
        { level: 18, name: 'Draconic Presence', type: 'Action', cost: '5 SP', desc: 'Aura of Fear or Awe.' }
    ],
    'Aberrant Sorcery': [
        { level: 3, name: 'Psionic Spells', type: 'Passive', desc: 'Always known spells. Telepathic Speech.' },
        { level: 6, name: 'Psionic Sorcery', type: 'Passive', desc: 'Cast using SP cheaply (Subtle).' },
        { level: 14, name: 'Revelation in Flesh', type: 'Bonus Action', desc: 'Transform for movement/defense.' },
        { level: 18, name: 'Warping Implosion', type: 'Action', desc: 'Teleport and vacuum damage.' }
    ],
    'Clockwork Sorcery': [
        { level: 3, name: 'Clockwork Magic', type: 'Passive', desc: 'Always known spells. Restore Balance.' },
        { level: 6, name: 'Bastion of Law', type: 'Action', desc: 'Ward damage using SP (d8 reduction).' },
        { level: 14, name: 'Trance of Order', type: 'Bonus Action', desc: 'Take 10 on rolls.' },
        { level: 18, name: 'Clockwork Cavalcade', type: 'Action', desc: 'Restore order in area (Heal/Repair/Dispel).' }
    ],
    'Wild Magic': [
        { level: 3, name: 'Wild Magic Surge', type: 'Passive', desc: 'Roll d20 after spell. Tides of Chaos.' },
        { level: 6, name: 'Bend Luck', type: 'Reaction', cost: '2 SP', desc: 'd4 to check/attack/save.' },
        { level: 14, name: 'Controlled Chaos', type: 'Passive', desc: 'Roll twice on surge table.' },
        { level: 18, name: 'Spell Bombardment', type: 'Passive', desc: 'Exploding dice on spell damage.' }
    ],

    // Warlock (Starts Lv 3)
    'Fiend Patron': [
        { level: 3, name: 'Dark One\'s Blessing', type: 'Passive', desc: 'Gain THP on kill.' },
        { level: 6, name: 'Dark One\'s Own Luck', type: 'Free', cost: '1 Use', desc: 'Add d10 to ability check/save.' },
        { level: 10, name: 'Fiendish Resilience', type: 'Passive', desc: 'Resistance to one damage type.' },
        { level: 14, name: 'Hurl Through Hell', type: 'Free', cost: '1 Use', desc: '10d10 psychic damage on hit.' }
    ],
    'Archfey Patron': [
        { level: 3, name: 'Steps of the Fey', type: 'Bonus Action', desc: 'Teleport. Charm/Frighten nearby.' },
        { level: 6, name: 'Misty Escape', type: 'Reaction', desc: 'Teleport and Invisible on damage. (Or improved Steps).' },
        { level: 10, name: 'Beguiling Defenses', type: 'Passive', desc: 'Immune charm, reflect charm.' },
        { level: 14, name: 'Dark Delirium', type: 'Action', desc: 'Plunge creature into illusion.' }
    ],
    'Celestial Patron': [
        { level: 3, name: 'Healing Light', type: 'Bonus Action', desc: 'Pool of d6 healing.' },
        { level: 3, name: 'Radiant Soul', type: 'Passive', desc: 'Resist Radiant, +Cha to damage. (Usually Lvl 6?).' }, // Shifted for logic
        { level: 10, name: 'Celestial Resilience', type: 'Passive', desc: 'THP on rest.' },
        { level: 14, name: 'Searing Vengeance', type: 'Reaction', desc: 'Resurrect and blind enemies.' }
    ],
    'Great Old One Patron': [
        { level: 3, name: 'Awakened Mind', type: 'Passive', desc: 'Telepathy. Psychic Spells.' },
        { level: 6, name: 'Entropic Ward', type: 'Reaction', desc: 'Disadvantage on attack, then Advantage.' }, // 2024 Mechanics distinct?
        { level: 10, name: 'Thought Shield', type: 'Passive', desc: 'Resist Psychic, no mind read. Reflect Dmg.' },
        { level: 14, name: 'Create Thrall', type: 'Action', desc: 'Summon aberration? (Changed from Thrall).' }
    ],

    // Wizard (Starts Lv 3)
    'Evoker': [
        { level: 3, name: 'Evocation Savant', type: 'Passive', desc: 'Half cost/time for Evocation. Sculpt Spells.' },
        { level: 6, name: 'Potent Cantrip', type: 'Passive', desc: 'Half damage on save for cantrips.' },
        { level: 10, name: 'Empowered Evocation', type: 'Passive', desc: 'Add Int to damage rolls.' },
        { level: 14, name: 'Overchannel', type: 'Free', desc: 'Max damage of 1-5 lvl spell (take dmg on reuse).' }
    ],
    'Abjurer': [
        { level: 3, name: 'Abjuration Savant', type: 'Passive', desc: 'Arcane Ward. Half cost for Abjuration.' },
        { level: 6, name: 'Projected Ward', type: 'Reaction', desc: 'Ward takes damage for ally.' },
        { level: 10, name: 'Spell Breaker', type: 'Passive', desc: 'Dispel Magic on Counterspell/Dispel success? Or Adds Prof?' },
        { level: 14, name: 'Spell Resistance', type: 'Passive', desc: 'Resistance to spell damage, advantage on saves.' }
    ],
    'Diviner': [
        { level: 3, name: 'Divination Savant', type: 'Passive', desc: 'Portent (2 Dice).' },
        { level: 6, name: 'Expert Divination', type: 'Passive', desc: 'Regain slots when casting divination.' },
        { level: 10, name: 'The Third Eye', type: 'Bonus Action', desc: 'Darkvision / See Invis.' },
        { level: 14, name: 'Greater Portent', type: 'Passive', desc: 'Roll 3d20.' }
    ],
    'Illusionist': [
        { level: 3, name: 'Illusion Savant', type: 'Passive', desc: 'Improved Minor Illusion (Sound+Image). BA Illusion.' },
        { level: 6, name: 'Malleable Illusions', type: 'Bonus Action', desc: 'Change nature of illusion.' },
        { level: 10, name: 'Illusory Self', type: 'Reaction', desc: 'Attack misses you.' },
        { level: 14, name: 'Illusory Reality', type: 'Bonus Action', desc: 'Make illusion real.' }
    ]
};
